import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  QuoteRequestNotificationsDelaySchema,
  QuoteRequestStatusSchema,
  UserSchema,
  UserSettingsSchema,
  UserSettingsWithRelationsSchema,
} from "../generated/prisma/zod";

const c = initContract();

export const usersContract = c.router({
  update: {
    method: "PATCH",
    path: "/users/me",
    body: z.object({
      firstName: z.string().optional(),
      lastName: z.string().optional(),
    }),
    responses: {
      200: UserSchema,
    },
  },
  settings: {
    update: {
      method: "PATCH",
      path: "/users/me/settings",
      body: z.object({
        quoteFollowUpEnabled: z.boolean().optional(),
        quoteRequestNotificationsDelays: z
          .object({
            id: z.string().optional(),
            quoteRequestStatus: QuoteRequestStatusSchema,
            delay: z.number(),
          })
          .array()
          .optional(),
        outlookConnectionEnabled: z.boolean().optional(),
      }),
      responses: {
        200: UserSettingsWithRelationsSchema,
      },
    },
  },
  team: {
    get: {
      method: "GET",
      path: "/users/team",
      responses: {
        200: UserSchema.array(),
      },
    },
  },

  me: {
    method: "GET",
    path: "/users/me",
    responses: {
      200: UserSchema.extend({
        userSettings: UserSettingsSchema.extend({
          quoteRequestNotificationsDelays: QuoteRequestNotificationsDelaySchema.array(),
        }),
      }),
    },
  },
  outlookAccount: {
    method: "GET",
    path: "/users/me/outlook",
    responses: {
      200: z.object({
        isConnected: z.boolean(),
        isOutlookConnectionEnabled: z.boolean(),
      }),
    },
  },
});
